import { UPDATE_SERVICES } from "../constants";

const initialState = null;

export const setServicesData = (data) => ({
    type: UPDATE_SERVICES,
    data,
});

export const services = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SERVICES:
            return action.data;
        default:
            return state;
    }
};